import { createSelector } from 'reselect'
import {
  fetchingStatusesSelector,
  isAuthenticatedSelector,
  selectDeviceTypeIsMobile,
} from 'selectors/app'
import { selectCurrentTicketChangesetsLoaded } from 'selectors/currentChangesets'
import { selectIsInInbox } from 'selectors/location'

import { dirtyTicketIdsSelector } from './dirty'
import { selectCurrentTicketUndecorated } from './current'

export const shouldFetchTicketSelector = createSelector(
  isAuthenticatedSelector,
  selectCurrentTicketUndecorated,
  fetchingStatusesSelector,
  dirtyTicketIdsSelector,
  selectDeviceTypeIsMobile,
  selectCurrentTicketChangesetsLoaded,
  selectIsInInbox,
  (
    auth,
    ticket,
    statuses,
    dirtyTicketIds,
    isMobile,
    areChangesetsLoaded,
    isInbox
  ) => {
    if (!isInbox) return false
    if (!auth) return false
    // not if we're currently fetching
    if (statuses.fetchTicket) return false
    if (ticket && ticket.loadFailed) return false
    if (!ticket) return true
    if (isMobile && !areChangesetsLoaded) return true
    if (!ticket.full) return true
    if (dirtyTicketIds[ticket.id]) return true
    return false
  }
)
